import React, { FC } from 'react'
import { Info16Regular } from '@fluentui/react-icons';
import { Tooltip,Checkbox } from '@fluentui/react-components';
import './checkBoxWithTooltip.scss'

interface ICheckBoxWithTooltipProps {
    checked: boolean,
    onChecked: any,
    tooltip: string,
    label: string,
    style?: any
    hidden?: boolean
}


const CheckBoxWithTooltip: FC<ICheckBoxWithTooltipProps> = (props: ICheckBoxWithTooltipProps) => {
    return (
        <div className="checkBoxWithTooltip" hidden={props.hidden}>
            <Checkbox style={props.style} label={props.label}
                checked={props.checked}
                onChange={(e, data) => props.onChecked(!!data.checked)} />
            <Tooltip content={props.tooltip} relationship='label'>
                <Info16Regular title={props.tooltip} className="succeeded" />
            </Tooltip>
        </div>)
}

export default CheckBoxWithTooltip;